export default function($element1, $element2) {
    $element1 = $element1 instanceof Node ? $($element1) : $element1;
    $element2 = $element2 instanceof Node ? $($element2) : $element2;
    if(!$element1.length || !$element2.length) {
        return $();
    }

    return $element1.parents().filter(
        $element2.parents()
    ).first();
}
